import React from 'react';
import { Link } from 'react-router-dom';

export default function RequestsDocs({ topic, setTopic, userInfo, schoolType }) {
	const isSupervisor = userInfo && `${userInfo.role_id}` === '3';
	const validTopics = ['search_requests', 'upload_requests', 'sort_request_courses', 'filter_by_department', 'expand_collapse_course', 'view_request_counts', 'edit_requests', 'select_students', 'bulk_edit_requests'].filter(topic_option => !isSupervisor || !['upload_requests', 'edit_requests', 'select_students', 'bulk_edit_requests'].includes(topic_option));
	const requestsTopic = validTopics.includes(topic) ? topic : 'default';

	const chooseRequestsTopic = (newTopic) => {
		if (requestsTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}
	};

	const videoPlaceholder = { backgroundColor: '#000', borderRadius: '8px', color: '#fff', minHeight: '240px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px', padding: '20px', textAlign: 'center' };

	return (
		<div className='documentation-page'>
			<div className='step-main-heading'>Requests</div>
			<p className='documentation-question-heading'>What do you need help with?</p>
			<div className='choose-topic'>
				<Link className={`choose-topic-btn ${requestsTopic === 'search_requests' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/requests/${requestsTopic === 'search_requests' ? 'null' : 'search_requests'}`} onClick={() => chooseRequestsTopic('search_requests')}>Search Requests</Link>
				{!isSupervisor && <Link className={`choose-topic-btn ${requestsTopic === 'upload_requests' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/requests/${requestsTopic === 'upload_requests' ? 'null' : 'upload_requests'}`} onClick={() => chooseRequestsTopic('upload_requests')}>Upload Requests</Link>}
				<Link className={`choose-topic-btn ${requestsTopic === 'sort_request_courses' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/requests/${requestsTopic === 'sort_request_courses' ? 'null' : 'sort_request_courses'}`} onClick={() => chooseRequestsTopic('sort_request_courses')}>Sort Request Courses</Link>
				<Link className={`choose-topic-btn ${requestsTopic === 'filter_by_department' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/requests/${requestsTopic === 'filter_by_department' ? 'null' : 'filter_by_department'}`} onClick={() => chooseRequestsTopic('filter_by_department')}>Filter By Department</Link>
				<Link className={`choose-topic-btn ${requestsTopic === 'expand_collapse_course' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/requests/${requestsTopic === 'expand_collapse_course' ? 'null' : 'expand_collapse_course'}`} onClick={() => chooseRequestsTopic('expand_collapse_course')}>Expand Or Collapse A Course</Link>
				<Link className={`choose-topic-btn ${requestsTopic === 'view_request_counts' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/requests/${requestsTopic === 'view_request_counts' ? 'null' : 'view_request_counts'}`} onClick={() => chooseRequestsTopic('view_request_counts')}>View Request Counts</Link>
				{!isSupervisor && <Link className={`choose-topic-btn ${requestsTopic === 'edit_requests' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/requests/${requestsTopic === 'edit_requests' ? 'null' : 'edit_requests'}`} onClick={() => chooseRequestsTopic('edit_requests')}>Edit Requests For A Course</Link>}
				{!isSupervisor && <Link className={`choose-topic-btn ${requestsTopic === 'select_students' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/requests/${requestsTopic === 'select_students' ? 'null' : 'select_students'}`} onClick={() => chooseRequestsTopic('select_students')}>Select Students In A Course</Link>}
				{!isSupervisor && <Link className={`choose-topic-btn ${requestsTopic === 'bulk_edit_requests' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/requests/${requestsTopic === 'bulk_edit_requests' ? 'null' : 'bulk_edit_requests'}`} onClick={() => chooseRequestsTopic('bulk_edit_requests')}>Bulk Edit Course Requests</Link>}
			</div>

			{requestsTopic === 'search_requests' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Search Requests</h2>
					<div className='documentation-step-text'>Search by course code or course name to quickly find request groups.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{requestsTopic === 'upload_requests' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Upload Requests</h2>
					<div className='documentation-step-text'>Use the Upload button to import student request data.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{requestsTopic === 'sort_request_courses' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Sort Request Courses</h2>
					<div className='documentation-step-text'>Sort the course list by Course Code or Course name.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{requestsTopic === 'filter_by_department' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Filter By Department</h2>
					<div className='documentation-step-text'>Filter the request course list by department.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{requestsTopic === 'expand_collapse_course' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Expand Or Collapse A Course</h2>
					<div className='documentation-step-text'>Use the chevron icon to open or close a course request list.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{requestsTopic === 'view_request_counts' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>View Request Counts</h2>
					<div className='documentation-step-text'>See total requests, alternate counts, and inclusion counts per course.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{requestsTopic === 'edit_requests' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Edit Requests For A Course</h2>
					<div className='documentation-step-text'>Open the Edit Requests modal window for the selected course.</div>
					<div className='documentation-step-text'>For schools that use the same course code for general education and inclusion, use the Inclusion toggle on an individual request to choose which type of section should fulfill it.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{requestsTopic === 'select_students' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Select Students In A Course</h2>
					<div className='documentation-step-text'>Select students in an expanded course list to prepare for bulk edits.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{requestsTopic === 'bulk_edit_requests' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Bulk Edit Course Requests</h2>
					<div className='documentation-step-text'>Use bulk actions to update selected student requests for the current course.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
		</div>
	);
}
